<elder-basic-pane-layout class="full">
  <elder-pane class="flex-30">
    <!-- storage browser -->
    <app-storage-node-browser
      class="flex"
      [canAdd]="true"
      (nodeClick)="currentNode = $event"
      (pathChange)="onPathChange($event)"
      (newNode)="onNewNode($event)"
    >
    </app-storage-node-browser>
  </elder-pane>

  <!-- storage node detail -->
  <elder-pane>
    <app-storage-node-detail
      class="flex"
      [embedded]="true"
      [node]="currentNode$ | async"
      (close)="currentNode = null"
    >
    </app-storage-node-detail>
  </elder-pane>
</elder-basic-pane-layout>
